export const WIDGET_VISIBILITY = {
	true: { name: 'On', value: 'on' },
	false: { name: 'Off', value: 'off' },
};

export const WIDGET_TYPE = {
	hero: 'hero_banner',
	highlight: 'highlight_banner',
	small: 'small_banner',
	shortcut: 'shortcut_banner',
	content: 'content_banner',
	brandBanner: 'brand_banner',
	shop_by_brand: 'shop_by_brand_banner',

	category: 'category',

	flashSale: 'flash_sale',

	products: 'products',
	productHighlight: 'product_highlight',
	product_category: 'product_category',

	highlightContentBlock: 'highlight_content_block',
	stripeContentBlock: 'stripe_content_block',
	textWithImageContentBlock: 'text_with_image',

	// static widgets
	product: 'product',
	wysiwyg: 'wysiwyg',
	custom_hero: 'custom_hero_banner',
	highlight_lob_banner: 'highlight_lob_banner',
	highlight_lob: 'highlight_lob_banner',
	lob: 'lob_banner',

	// Braze
	brazeProducts: 'braze_products',
	brazeImage: 'braze_image_banner',
	brazeMobileCanvas: 'braze_mobile_canvas',
};

export const WIDGET_TYPE_LABEL = {
	[WIDGET_TYPE.hero]: 'Hero banner',
	[WIDGET_TYPE.custom_hero]: 'Custom hero banner',
	[WIDGET_TYPE.highlight]: 'Highlight banner',
	[WIDGET_TYPE.small]: 'Small banner',
	[WIDGET_TYPE.flashSale]: 'Flash sale',
	[WIDGET_TYPE.products]: 'Product',
	[WIDGET_TYPE.shortcut]: 'Shortcut banner',
	[WIDGET_TYPE.content]: 'Content banner',
	[WIDGET_TYPE.brandBanner]: 'Brand banner',
	[WIDGET_TYPE.productHighlight]: 'Product highlight banner',
	[WIDGET_TYPE.shop_by_brand]: 'Shop by brand banner',
	[WIDGET_TYPE.highlightContentBlock]: 'Highlight content block',
	[WIDGET_TYPE.textWithImageContentBlock]: 'Text with image content block',
	[WIDGET_TYPE.stripeContentBlock]: 'Stripe content block',
	[WIDGET_TYPE.product_category]: 'Product category banner',
	// Cart recommend types map to same values so specific labels are not needed (keys are identical)

	// Braze
	[WIDGET_TYPE.brazeProducts]: 'Braze products',
	[WIDGET_TYPE.brazeImage]: 'Braze image banner',
	[WIDGET_TYPE.brazeMobileCanvas]: 'Braze mobile canvas',

	[WIDGET_TYPE.custom_hero]: 'Custom hero banner',
	[WIDGET_TYPE.highlight_lob_banner]: 'Highlight LOB banner',
	[WIDGET_TYPE.lob]: 'LOB banner',
	[WIDGET_TYPE.highlight_lob]: 'Highlight LOB banner',
	[WIDGET_TYPE.product]: 'Product',
	[WIDGET_TYPE.wysiwyg]: 'Wysiwyg',
};

export const WIDGET_TYPE_EDITABLE = [
	WIDGET_TYPE.highlight,
	WIDGET_TYPE.small,
	WIDGET_TYPE.flashSale,
	WIDGET_TYPE.shortcut,
	WIDGET_TYPE.content,
	WIDGET_TYPE.products,
	WIDGET_TYPE.brandBanner,
	WIDGET_TYPE.productHighlight,
	WIDGET_TYPE.shop_by_brand,
	WIDGET_TYPE.highlightContentBlock,
	WIDGET_TYPE.textWithImageContentBlock,
	WIDGET_TYPE.stripeContentBlock,

	// static widgets
	WIDGET_TYPE.product,
	WIDGET_TYPE.wysiwyg,
	WIDGET_TYPE.custom_hero,
	WIDGET_TYPE.highlight_lob_banner,
	WIDGET_TYPE.highlight_lob,
	WIDGET_TYPE.lob,

	// braze
	WIDGET_TYPE.brazeProducts,
	WIDGET_TYPE.brazeImage,
	WIDGET_TYPE.brazeMobileCanvas,
];

export const WIDGET_STATUSES = {
	ongoing: 'Ongoing',
	scheduled: 'Scheduled',
	active: 'Active',
	inactive: 'Inactive',
};

export const WIDGET_STORE_ID = {
	BNN: 1,
	MICROSITE: 2,
};
